const MAX_POPOVER_HEIGHT = 250;
const MAX_POPOVER_WIDTH = 400;
const POPOVER_BOTTOM_OFFSET = 20; // distance between bottom of chart and popover
const POPOVER_BAR_OFFSET = 10; // distance chart bar and popover
export interface Position {
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
}

/**
 * calculate the position for a popover with +dimensions+ placed next to a bar.
 * @param barElement what to position the popover next to
 * @param chartElement popover can't go past the bottom
 * @param viewerElement popover can't cross the the left or right boundary
 * @param dimensions height, width, and positioning constraints for the popover
 * @param dimensions.height height to use for positioning
 * @param dimensions.width width to use for positioning
 * @param dimensions.xOffset how far away to place it from the barElement
 * @param dimensions.bottomOffset how far away to place it from the bottom of the chartElement
 */
export function calculatePopoverPosition({
  barElement,
  chartElement,
  viewerElement,
  dimensions = {
    height: MAX_POPOVER_HEIGHT,
    width: MAX_POPOVER_WIDTH,
    bottomOffset: POPOVER_BOTTOM_OFFSET,
    xOffset: POPOVER_BAR_OFFSET,
  },
}: {
  barElement: HTMLElement;
  chartElement: HTMLElement;
  viewerElement: HTMLElement;
  dimensions?: {
    height: number;
    width: number;
    xOffset: number;
    bottomOffset: number;
  };
}): Position {
  const styles: Position = {};

  const barRect = barElement.getBoundingClientRect();
  const viewerRect = viewerElement.getBoundingClientRect();
  const top = barRect.top - viewerRect.top;
  const left = barRect.right - viewerRect.left + dimensions.xOffset;
  // remove comments disabling linters with TODO on line 366 (we need both, we have a lot of linters...)
  // @ts-ignore
  const chartBottom = chartElement.getBoundingClientRect().bottom - viewerRect.top; // eslint-disable-line

  // @ts-ignore
  const popoverBottom = top + dimensions.height; // eslint-disable-line
  const popoverRightSide = left + dimensions.width;
  const right = -(barRect.left - viewerRect.right - dimensions.xOffset);

  // don't let popover overflow right
  if (popoverRightSide > viewerRect.right) {
    styles.right = `${right}px`;
  } else {
    styles.left = `${left}px`;
  }

  /* TODO(sam) uncomment the check to prevent popover overflowing bottom
  // Context: funnels viewer is in the middle of a refactor to move some of the
  // handling logic to a wrapper component (/iron/common/widgets/funnels-steps-view)
  // and part of this refactor involves a move of the chart references. This means that
  // the offset bottom goes from the bottom of the table instead of the chart, and to
  // ensure that the popover is in the correct position, we comment out this option for now

  // don't let popover overflow bottom
  if (popoverBottom > chartBottom) {
    styles.bottom = `${dimensions.bottomOffset}px`;
  }
  */

  styles.top = `${top}px`;

  return styles;
}
